<div>
  <div *ngIf="supplierId" style="display: flex">
    <h2 class="flex-grow-1 sub-header-bar" style="margin-top: 5px">This Week's Schedule</h2>
    <div class="flex-shrink-1" style="margin-bottom: 5px">
      <button
        pButton
        label="View Supplier Availability"
        class="btn btn-sm"
        (click)="navigateToSupplierSchedule()"
      ></button>
    </div>
  </div>

  <div class="flex flex-wrap" *ngIf="!supplierId">
    <div class="flex-grow-1 this-week-schedule">This Week's Schedule</div>
    <div class="flex-shrink-1 header-font-size view-full-schedule">
      <a (click)="navigateToSupplierSchedule()">
        View Full Schedule<i class="ml-1 fa fa-arrow-right"></i>
      </a>
    </div>
  </div>
  <div class="mb-3" *ngIf="!supplierId">
    <div class="availability-info-container">
      <div class="flex grid-gap-10">
        <div class="flex-shrink-1 availability-info-icon">
          <i class="fa fa-info-circle" style="color: #012169"></i>
        </div>
        <div class="flex-grow-1">
          If you set yourself to Unavailable or Do Not Disturb, Juno will not generate routes for
          those days.
        </div>
      </div>
    </div>
    To manage your availability, click on a date to cycle through:
    <span class="available">Available</span>, <span class="unavailable">Unavailable</span> and
    <span class="unavailable"><i class="fa fa-minus-circle"></i>&nbsp;Do Not Disturb</span>
    <app-availability-help></app-availability-help>
  </div>

  <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>

<p-dialog
  [(visible)]="showRangeSelectionDialog"
  [responsive]="true"
  [modal]="true"
  [closeOnEscape]="false"
  (onHide)="(!showRangeSelectionDialog)"
  header="Range Selection Action"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="grid">
      <div class="col-4 sm:col-3 md:col-2" style="margin-top: 30px">
        <i class="pi pi-calendar" style="font-size: 6em"></i>
      </div>
      <div class="col-8 sm:col-9 md:col-10 grid">
        <div class="mt-4 col-12">
          <p>
            You have selected the dates from
            {{ selectedDateRangeStart | datex : 'ddd DD MMM YYYY' }} until
            {{ selectedDateRangeEndDisplay | datex : 'ddd DD MMM YYYY HH:mm:ss' }}
          </p>
          <p>What would you like to do?</p>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Do Not Disturb"
            icon="fa fa-minus-circle"
            (click)="setDateRangeAvailability(availabilityStates.doNotDisturb)"
            class="ui-button red-state-btn w-full"
          ></button>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Unavailable"
            (click)="setDateRangeAvailability(availabilityStates.unavailable)"
            class="ui-button red-state-btn w-full"
          ></button>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Available"
            (click)="setDateRangeAvailability(availabilityStates.available)"
            class="ui-button green-state-btn w-full"
          ></button>
        </div>
      </div>
    </div>
  </div>
  <p-footer class="text-center mt-2">
    <button
      type="button"
      pButton
      label="Cancel"
      (click)="showRangeSelectionDialog = false"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog>
